module.exports = __webpack_public_path__ + "img/qrcode.9cea48d4.png";